var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data_market mt20" },
    [_c("dataPresentation"), _vm._v(" "), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ech_box" }, [
      _c("div", { staticClass: "echarts", attrs: { id: "main" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }